import firebase from "firebase/app";
import "firebase/messaging";
import { logError } from "utils/error";
import {
  getLocalStorageItem,
  setLocalStorageItem,
} from "features/Common/modules/Storage/modules/LocalStorage/utils/LocalStorage.utils";
import { LOCAL_STORAGE_KEYS } from "features/Common/modules/Storage/modules/LocalStorage/constants/LocalStorage.constants";
import { SESSION_STORAGE_KEYS } from "features/Common/modules/Storage/modules/SessionStorage/constants/SessionStorage.constant";
import { getSessionStorageItem } from "features/Common/modules/Storage/modules/SessionStorage/utils/SessionStorage.utils";
import { saveFCMToken } from "./apiCalls/saveFCMToken";
import { CREATOR_ROLE_POWER } from "features/Common/constants/rolePowers.constants";
import { FIREBASE_CONFIG } from "../constants/Firebase.constants";

export const getFcmToken = async (swRegisteration) => {
  const existingFCMToken = getLocalStorageItem(LOCAL_STORAGE_KEYS.FCM_TOKEN);
  try {
    if (!firebase.apps.length) {
      firebase.initializeApp(FIREBASE_CONFIG);
    } else {
      firebase.app();
    }
    const messaging = firebase.messaging();
    const token = await messaging.getToken({
      vapidKey: process.env.REACT_APP_FIRBASE_VAPID_KEY,
      serviceWorkerRegistration: swRegisteration,
    });

    if (token && token !== existingFCMToken) {
      // Save token to server to save it for sending notifications
      saveFCMToken(token);
      setLocalStorageItem(LOCAL_STORAGE_KEYS.FCM_TOKEN, token);
    }
  } catch (error) {
    logError({
      error,
      when: "getFcmToken",
      occuredAt: "src/features/FCMNotifications/Firebase.utils.js",
    });
  }
};

export const requestNotificationPermission = async (swRegisteration) => {
  try {
    const rolePowers = JSON.parse(
      getSessionStorageItem(SESSION_STORAGE_KEYS.ROLE_POWERS) || "{}"
    );
    const isCreator = rolePowers?.role_type === CREATOR_ROLE_POWER;
    // if REACT_APP_ENABLE_NOTIFICATIONS_FOR_ALL is true, then allow notifications for all staff members as well else only for creators
    if (
      !isCreator &&
      process.env.REACT_APP_ENABLE_NOTIFICATIONS_FOR_ALL !== "true"
    ) {
      return;
    }
    const permission = await Notification.requestPermission();
    if (permission === "granted" && firebase.apps.length) {
      getFcmToken(swRegisteration);
    }
  } catch (error) {
    logError({
      error,
      when: "requestNotificationPermission",
      occuredAt: "src/features/FCMNotifications/Firebase.utils.js",
    });
  }
};

export const initializeFCM = () => {
  try {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.ready
        .then((readyReg) => {
          requestNotificationPermission(readyReg);
        })
        .catch((error) => {
          logError({
            error,
            when: "serviceWorker.ready",
            occuredAt: "src/features/FCMNotifications/utils/Firebase.utils.js",
          });
        });
    }
  } catch (err) {
    logError({
      error: err,
      when: "initializeFCM",
      occuredAt: "src/features/FCMNotifications/utils/Firebase.utils.js",
    });
  }
};
